<p-dialog [(visible)]="changeRepresentativeModal" [resizable]="false" appendTo="body" [modal]="true" [closeOnEscape]="true" (onHide)="closeDialogEvent()" [breakpoints]="{'767px': '100vw'}" [style]="{width: '660px'}" styleClass="no-header-modal overflow-visible">
  
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <ng-container *ngIf="{
      client: allClientData$ | async,
      staff: currentStaff$ | async,
      selectedStaff: selectedStaff$ | async
    } as $">

    <!-- Header -->
    <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
      <div class="flex align-items-center">
        <h2 class="mb-0 text-sm">{{'CLIENT_PROFILE.CHANGE_CLIENT_REP' | translate}} <strong>{{$.client.full_name}}</strong>
          <span class="text-xs text-600"> - {{$.client.id}}</span></h2>
      </div>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialogEvent()"></div>
    </div>
    <!-- Header -->

    <form [formGroup]="updateClientRepFormGroup" (ngSubmit)="updateClientRepresentative()">

    <!-- Modal Content -->
    <div class="surface-100 border-bottom-1 border-300 p-3 md:px-5">

      <!-- Column -->
      <div class="mb-4">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALE_REPRESENTATIVE.CURRENT_SALES_REP' | translate}}</label>

        <div class="flex align-items-center">
          <span *ngIf="$.staff.ff_picture; else noContactPic">
            <p-avatar image="{{$.staff.ff_picture}}" class="w-2rem h-2rem border-circle mr-2" shape="circle"></p-avatar>
          </span>
          <ng-template #noContactPic>
            <p-avatar styleClass="mr-2" *ngIf="$.staff.name" label="{{$.staff.name | titlecase | shortName}}" shape="circle"></p-avatar>
          </ng-template>
          <span class="text-sm">{{$.staff.name}}</span>
        </div>
        </div>
      <!-- Column -->

      <!-- Column -->
      <div class="">
        <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SALE_REPRESENTATIVE.NEW_SALES_REP' | translate}}</label>
        <!-- <div class="relative"> -->
          <staff-selector [formGroup]="updateClientRepFormGroup" [controlName]="NewRepresentative"
           [canRepresetative]="isClientRepresentative" [claims]="claims" [styleClass]="'w-full text-sm py-0 align-items-center'">
          </staff-selector>
        <!-- </div> -->
      </div>
      <!-- Column -->

    </div>
    <!-- Modal Content -->

    <!-- Modal Footer -->
    <div class="flex align-items-center justify-content-between border-top-1 border-300 p-3">
      <div class="w-4">
        <p-button type="button" [label]="'SALE_REPRESENTATIVE.CANCEL' | translate" styleClass="p-button-link p-0 text-sm" (click)="closeDialogEvent()"></p-button>
      </div>
      <div class="w-8 text-right">
        <p-button type="submit" styleClass="text-sm" [disabled]="!updateClientRepFormGroup.valid" [label]="'SALE_REPRESENTATIVE.UPDATE_SALES_REP' | translate"
        [loading]="isloading"></p-button>
      </div>
    </div>
    <!--Modal Footer -->

  </form>
  </ng-container>
  </ng-template>

</p-dialog>
